import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, easeOut } from "framer-motion";

import { Typography, Button } from '@mui/material';
import sessionstorage from 'sessionstorage';

import Classes from "./SectionA.module.css";
import '../Home.css'

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Navbar from './Navbar/Navbar';
import Dashboard from '../../../../Panels/Agency/Pages/Activity/Dashboard/Dashboard';

function SectionA() {
  const [width, setWidth] = useState(window.innerWidth);
  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const navigateToSignup = () => {
    navigate('/signup', { state: { data: "toSignup" } });
  }

  const navigateToUpload = async () => {
    await sessionstorage.setItem("navBtn", "Pitch Deck Dashboard")

    if (user) {

      navigate('/dashboard')
    } else {
      navigate('/login')
    }

  }

  const goToDemo = () => {
    navigate('/demo');
  }

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <>
      <section id='home' className={Classes.home} >
        <div className={Classes.customBox}>
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.2 // Delay before animation starts
            }}>
            <Navbar />
          </motion.div>
          <motion.div
            whileTap={{ scale: 0.90 }}
            initial={{ opacity: 0, y: 250 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4,
              ease: easeOut,
              delay: 1
            }}
          >
            <motion.div
              whileTap={{ scale: 0.95 }}
              className={Classes.miniBanner}
            >
              <button type='button' > <h5>New</h5> </button>
              <h5>Build your onboarding dashboard {'>'}</h5>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 250 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4,
              ease: easeOut,
              delay: 1.2
            }}
          >
            <h1 className={Classes.Txt1} >
              The complete client onboarding
            </h1>

            <h1 className={Classes.Txt1} >
              and management platform
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 150 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.5 // Delay before animation starts
            }}
          >
            <h5 className={Classes.Txt2} >
              Bring your clients, projects, tasks, payments and communications together—seamlessly.
            </h5>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.8 // Delay before animation starts
            }}
            whileTap={{ scale: 0.90 }}
            className={Classes.home_btns_con}
          >
            <div className={Classes.home_btns}>
              <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
              >
                <button className={Classes.startBtn} onClick={navigateToSignup} > <h5>Get started for free</h5> </button>
              </motion.div>
            </div>
          </motion.div>

        </div>
      </section>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: .4, // Total duration of the animation
          ease: easeOut, // Custom easing curve
          delay: 1 // Delay before animation starts
        }} className={Classes.gradientBackground} >
        {/* <LazyLoadImage
          effect="opacity"
          src='/assets/images/background-main.png'
          className={Classes.card_inner_img}
        /> */}
      </motion.div>
    </>
  );
}

export default SectionA;